export default __webpack_public_path__ + "static/media/lets_code_mobile_app.9357e955.jpeg";